<template>
    <div class="area-box" @keydown.ctrl.enter="send">
        <div v-if="!uid" class="area-mask" :style="`height: ${areaHeight}`">
            请先 <span @click="sign.sign_box_show = true" class="sign-btn">登录</span> 后再发表评论
        </div>
        <div v-if="uid && !user.phone" class="area-mask" :style="`height: ${areaHeight}`">
            请先 <span @click="sign.phone_box_show = true" class="sign-btn">绑定手机</span> 后再发表评论
        </div>
        <div
            v-if="uid && user.phone"
            ref="area"
            :class="`area${emojiShow ? ' area-active' : ''}`"
            contenteditable="true"
            :placeholder="placeholder"
            @input="input"
            :style="`min-height: ${areaHeight};padding: ${areaPadding}`"
        >
        </div>
        <div :class="`send-box${emojiShow ? ' active' : ''}`">
            <div>
                <i @click.stop="toggle" class="fl icon-emoji" />
                <span class="fl comment-tips">Ctrl+Enter 发表</span>
            </div>
            <div v-show="emojiShow" ref="emotion" class="emotion-box">
                <div class="emotion-list">
                    <i v-for="v in emoji.data" @click="addEmoji(v)">{{v}}</i>
                </div>
                <div class="emoji-cover">😃</div>
            </div>
            <div class="comment-button-box">
                <div v-if="showCancelButton" @click="cancel" class="cancel-button">取消</div>
                <div :class="`send-btn ${buttonClass}`" :style="`width: ${buttonWidth};height:${buttonHeight}`" @click="send">{{buttonName}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Area",
        props: {
            areaHeight: {
                type: String,
                default: 'inherit',
            },
            areaPadding: {
                type: String,
                default: '5px 2px 5px 6px',
            },
            buttonWidth: {
                type: String,
                default: '56px',
            },
            buttonHeight: {
                type: String,
                default: '26px',
            },
            buttonName: {
                type: String,
                default: '评论',
            },
            buttonClass: {
                type: String,
                default: '',
            },
            height: {
                type: String,
                default: '评论',
            },
            placeholder: {
                type: String,
                default: '写下你的评论...'
            },
            value: {
                type: String,
                default: ''
            },
            showCancelButton: {
                type: Boolean,
                default: false,
            },
            show: Boolean,
        },
        data() {
            return {
                key: 0,
                text: '',
                emoji_show: false,
            }
        },
        computed: {
            uid() {
                return this.user.id;
            },
            area() {
                return this.$refs.area;
            },
            state() {
                return this.$store.state;
            },
            sign() {
                return this.state.sign;
            },
            user() {
                return this.state.user;
            },
            emoji() {
                return this.state.emoji;
            },
            keys() {
                return this.emoji.keys;
            },
            openKey() {
                return this.emoji.openKey;
            },
            emojiShow() {
                return this.keys[this.key];
            }
        },
        watch: {
            show(val) {
                if (val) this.area.focus();
            },
            value(val) {
                if (val !== this.area.innerText) this.area.innerText = val;
            },
        },
        methods: {
            addEmoji(str) {
                const area = this.$refs.area;
                if (document.selection) {
                    area.focus();
                    const sel = document.selection.createRange();
                    sel.text = str;
                    sel.select();
                } else if (area.selectionStart || area.selectionStart === '0') {// Mozilla/NETSCAPE support
                    const startPos = area.selectionStart,
                        endPos = area.selectionEnd,
                        // save scrollTop before insert
                        restoreTop = area.scrollTop;
                    area.innerText = area.innerText.substring(0, startPos) + str + area.innerText.substring(endPos, area.innerText.length);
                    if (restoreTop > 0) {
                        // restore previous scrollTop
                        area.scrollTop = restoreTop;
                    }
                    area.focus();
                    area.selectionStart = startPos + str.length;
                    area.selectionEnd = startPos + str.length;
                } else {
                    const selection = window.getSelection();

                    // .nodeName === '#text'
                    if (selection.anchorNode && selection.anchorNode.nodeType === 3 && selection.anchorNode.parentNode === area) {// 光标选中
                        const range = selection.getRangeAt(0),
                            rangeStartOffset = range.startOffset,// 获取光标位置
                            textNode = range.startContainer;

                        if (!range.collapsed) {// 不是同一位置 代表选择了内容 则先删除选择的内容
                            range.deleteContents();
                        }

                        textNode.insertData(rangeStartOffset, str);// 文本节点在光标位置处插入新的表情内容
                        range.setStart(selection.anchorNode, rangeStartOffset + str.length);// 光标移动到表情的后面, 1个emoji的长度并不固定
                        range.collapse(true);// 光标开始和光标结束重叠
                        selection.removeAllRanges();// 清除选定对象的所有光标对象
                        selection.addRange(range);// 插入新的光标对象
                    } else {// 未出现光标 直接点击表情 默认插入最后位置
                        area.innerText += str;
                        selection.selectAllChildren(area);// 选择编辑器
                        selection.collapseToEnd();// 光标移动至最后
                    }
                    this.toggle();
                    this.input();
                }
            },
            toggle() {
                if (!this.user.id || !this.user.phone) return;
                if (this.emojiShow) {
                    this.close();// 关闭被打开的表情包
                } else {
                    this.close();
                    this.$set(this.keys, this.key, true);// 打开当前表情包
                    this.emoji.openKey = this.key;
                }
            },
            send() {
                if (!this.user.id || !this.user.phone) {
                    this.sign.sign_box_show = true;
                    return;
                }
                this.$emit('send');
            },
            cancel() {
                this.$emit('cancel');
            },
            input() {
                this.$emit('input', this.area.innerText);
            },
            close() {
                this.$set(this.keys, this.openKey, false);
            },
            /*closeEmoji() {
                const {target} = e;
                if (target && target.offsetParent && target.className !== 'emotion-box' && target.className !== 'icon-emoji' && target.offsetParent.className !== 'emotion-box')
            }*/
        },
        created() {
            this.keys.push(false);
            this.key = this.keys.length - 1;// 唯一标识

            if (this.emoji.hasCloseFn) return;
            this.emoji.hasCloseFn = true;
            document.addEventListener('click', this.close);
        },
        beforeDestroy() {
            const {emoji} = this;
            if (!emoji.hasCloseFn) return;
            emoji.hasCloseFn = false;
            emoji.keys = [];
            document.removeEventListener("click", this.close);
        }

    }
</script>

<style scoped>
    @import "../../../static/css/components/area.css";
</style>



// WEBPACK FOOTER //
// src/components/BaseArea/index.vue